'use client';

import SearchIcon from '@/components/icons/Action/SearchIcon';
import { Column } from '@tanstack/react-table';
import { FC } from 'react';
import styles from './style.module.scss';

const Filter: FC<{ column: Column<any, unknown> }> = ({ column }) => {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant } = column.columnDef.meta ?? {};

  return filterVariant === 'text' ? (
    <div className={styles['input-container']}>
      <SearchIcon className={styles['search-icon']} />
      <input
        type="text"
        onChange={(e) => column.setFilterValue(e.target.value)}
        placeholder={`Recherche`}
        value={(columnFilterValue ?? '') as string}
      />
    </div>
  ) : (
    <></>
  );
};

export default Filter;
